import React from 'react';
import { useMyMessageList } from '../../hooks/taskHooks';
import { Button } from 'primereact/button';
import {useNavigate} from "react-router-dom";
import {messageCenterIndexDashboard} from './DashboardSelector';
import {useDispatch} from "react-redux";
import {selectDashboard} from "../../redux/slices/kpiSlice";

const MessagesIcon = () => {
    
    const messageListLength = useMyMessageList({showOpenedOnly:true, unreadOnly: true, showDirectReporteeOnly: false, isOutbox: false})?.length ?? 0;
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    return (<>
        <Button label={messageListLength? messageListLength :""} icon="pi pi-bell" severity="warning" aria-label="Notification" className="mr-1"  
                            onClick={() => {
                                    dispatch(selectDashboard(messageCenterIndexDashboard));
                                    navigate('/');
                            }
        }/>
    </>);
}

export default MessagesIcon;